export default {
  frontRoutes: [
    {
      path: '/index/rec-goods',
      name: 'IndexRecommendGoods',
      component: () => import(/* webpackChunkName: "book" */ '../views/goods/Goods.vue'),
    },
    {
      path: '/goods',
      name: 'Goods',
      component: () => import(/* webpackChunkName: "book" */ '../views/goods/Goods.vue'),
    },
    {
      path: '/goods/coupon',
      name: 'GoodsCoupon',
      component: () => import(/* webpackChunkName: "book" */ '../views/goods/GoodsCoupon.vue'),
    },
    {
      path: '/goods/:id',
      name: 'GoodsDetail',
      component: () => import(/* webpackChunkName: "book" */ '../views/goods/GoodsDetail.vue'),
    },
  ],
  memberRoutes: [],
};
